var styleDataHash = "6e66fcad";
const injectCss = () => {
  var css = `.gg1Mt,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.loVLj{color:var(--ricos-settings-text-color,#000);width:100%}[dir] .loVLj{background-color:#fff}.loVLj._1HOZN{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}@supports not (contain:inline-size){@media only screen and (max-width:640px){.loVLj{height:47px}}}@container (width < 640px){.loVLj{height:47px}}.loVLj .UVLxy{align-items:center;display:grid;grid-auto-columns:max-content auto max-content;grid-auto-flow:column;height:40px;grid-gap:12px}[dir=ltr] .loVLj .UVLxy,[dir=rtl] .loVLj .UVLxy{padding-left:20px;padding-right:20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.loVLj .UVLxy.xH6Pe{grid-auto-columns:auto}}}@container (width < 640px){.loVLj .UVLxy.xH6Pe{grid-auto-columns:auto}}.loVLj .UVLxy .sgNZG{align-self:left}@supports not (contain:inline-size){@media only screen and (max-width:640px){.loVLj .UVLxy .sgNZG{display:flex;width:100%}}}@container (width < 640px){.loVLj .UVLxy .sgNZG{display:flex;width:100%}}.loVLj .UVLxy ._6Skpi{display:grid;grid-auto-flow:row}.loVLj .UVLxy ._6Skpi .CSplH{font-size:14px}.loVLj .UVLxy ._6Skpi .L86fg{color:#646464;font-size:12px}.loVLj .UVLxy .J1Nr-{align-self:right}.loVLj._1HOZN,.loVLj:active{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .loVLj._1HOZN,[dir] .loVLj:active{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.loVLj._1HOZN svg,.loVLj:active svg{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}[dir] .loVLj:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.05);cursor:pointer}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_select_default = {
  "fontElementMap": "gg1Mt",
  "container": "loVLj",
  "selected": "_1HOZN",
  "content": "UVLxy",
  "content_mobile_alignCenter": "xH6Pe",
  "prefix": "sgNZG",
  "titleWrapper": "_6Skpi",
  "title": "CSplH",
  "subtitle": "L86fg",
  "suffix": "J1Nr-"
};
export {
  list_item_select_default as default,
  injectCss
};
//# sourceMappingURL=list-item-select-scss.js.map
